import {
  COLORS,
  FONTS,
  CONTACT_INFO,
  CONTACT_US_TITLE,
  device,
} from '../../../../constants';

import PhoneNumberWithCountry from './PhoneNumberWithCountry';
import styled from 'styled-components';

export const ContactUs = () => {
  return (
    <ContactUsContainer>
      <MainText>
        Let
        <Dot />s develop software together!
      </MainText>
      <Phones>
        <StyledButton>{CONTACT_US_TITLE}</StyledButton>
        <PhoneNumberWithCountry
          country={CONTACT_INFO.FIRST_TITLE}
          phoneNumber={CONTACT_INFO.FIRST_NUMBER}
        />
        <PhoneNumberWithCountry
          country={CONTACT_INFO.SECOND_TITLE}
          phoneNumber={CONTACT_INFO.SECOND_NUMBER}
        />
        <PhoneNumberWithCountry
          country={CONTACT_INFO.THIRD_TITLE}
          phoneNumber={CONTACT_INFO.THIRD_NUMBER}
        />
        <PhoneNumberWithCountry
          country={CONTACT_INFO.FOURTH_TITLE}
          phoneNumber={CONTACT_INFO.FOURTH_NUMBER}
        />
        <PhoneNumberWithCountry
          country={CONTACT_INFO.FIFTH_TITLE}
          phoneNumber={CONTACT_INFO.FIFTH_NUMBER}
        />
      </Phones>
    </ContactUsContainer>
  );
};

const ContactUsContainer = styled.div`
  max-width: 420px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  @media screen and ${device.md} {
    flex-direction: row;
    max-width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
  }
  @media screen and ${device.sm} {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
    padding: 0;
    margin-bottom: 10px;
  }
  @media screen and ${device.xs} {
    gap: 5px;
  }
`;
const Phones = styled.div`
  display: flex;
  flex-direction: column;
`;
const MainText = styled.span`
  text-align: start;
  max-width: 420px;
  color: ${COLORS.WHITE};
  font-size: 40px;
  font-weight: 600;
  font-family: ${FONTS.TITLE};
  line-height: 44px;
  @media screen and ${device.lg} {
    max-width: 50%;
    font-size: 30px;
    line-height: 38px;
  }
  @media screen and ${device.sm} {
    max-width: 100%;
    font-size: 20px;
    line-height: 26px;
  }
`;

const Dot = styled.span`
  width: 6px;
  height: 6px;
  display: inline-block;
  border-radius: 50%;
  background-color: ${COLORS.MAIN_RED};
  margin: 0 0 20px 3px;
  @media screen and ${device.lg} {
    margin: 0 0 18px 3px;
  }
  @media screen and ${device.md} {
    margin: 0 0 15px 2px;
  }
  @media screen and ${device.sm} {
    width: 4px;
    height: 4px;
    margin: 0 0 11px 1px;
  }
`;

const StyledButton = styled.button`
  appearance: none;
  border: none;
  outline: none;
  background-color: transparent;
  color: ${COLORS.WHITE};
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  padding: 0;
  margin: 40px 0 20px 0;
  text-align: start;
  font-family: ${FONTS.SUBTITLE};
  @media screen and ${device.md} {
    margin: 0;
  }
  @media screen and ${device.sm} {
    margin-bottom: 25px;
  }
`;

ContactUs.displayName = 'ContactUs';
